import axios from 'axios';

const url = import.meta.env.VITE_API_URL.length === 1 ? window.location.origin : import.meta.env.VITE_API_URL;

const instance = axios.create({
  baseURL: url + '/api',
  withCredentials: true,
});

// Interceptador de requisição para incluir o token
instance.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  error => Promise.reject(error)
);

export default instance;
